export function resolveErrorMessage(error: unknown, fallback = 'Error desconocido'): string {
  if (typeof error === 'string') return error;
  if (error instanceof Error) return error.message;
  if (error && typeof error === 'object') {
    const maybeError = error as { message?: string; error?: { message?: string } };
    if (typeof maybeError.error?.message === 'string') return maybeError.error.message;
    if (typeof maybeError.message === 'string') return maybeError.message;
  }
  return fallback;
}
